import { z } from 'zod'
import type { TypeOfBusiness } from '../../models/TypeOfBusiness'

export const TypeOfBusinessDTO = z.object({
  id: z.number(),
  type: z.string(),
  description: z.string()
})

export type TypeOfBusinessDTO = z.infer<typeof TypeOfBusinessDTO>

export function mapTypeOfBusinessToDTO (model: TypeOfBusiness): TypeOfBusinessDTO {
  return {
    id: model.id!,
    type: model.type,
    description: model.description ?? ''
  }
}

export function mapDTOToTypeOfBusiness (dto: TypeOfBusinessDTO): TypeOfBusiness {
  return {
    id: dto.id,
    type: dto.type ?? '',
    description: dto.description ?? ''
  }
}
